import { JsonObject, JsonProperty } from 'json2typescript';
import { ClientDataInterface } from '../interfaces/client-data.interface';

@JsonObject('ClientData')
export class ClientData implements ClientDataInterface {
  AcceptEmailMarketing?: boolean;
  AcceptMarketing?: boolean;
  AdditionalFiscalCountries?: any;
  AcceptsFiscalProfile?: boolean;
  AdvisorCode?: any;
  AdvisorFullName?: any;
  AssetLiabilities2Y?: number;
  Language?: string;
  Agent?: Agent;
  BirthDate?: string;
  BranchCode?: any;
  Citizenship?: string;
  CityOfBirth?: string;
  ClientCode?: string;
  Code?: string;
  ConvenienceGroups?: string;
  CountRecordator?: number;
  CountryOfBirth?: string;
  CountryOfResidence?: string;
  Currency?: any;
  CurrentEquityAsset?: number;
  CurrentAssetLiabilities?: number;
  Date_last_test?: string;
  DisclaimerOnboardingChecked?: boolean;
  DocExpirationDate?: string;
  DocExpirationDatePermanent?: boolean;
  DocId?: string;
  DocType?: string;
  Email?: string;
  EquityAsset2Y?: number;
  ExpirationDateLegalEntityId?: string;
  FATCACRSData?: any;
  Gender?: string;
  HabitualResidence?: HabitualResidence;
  HasCredentials?: boolean;
  Id?: string;
  IdDocumentNumber?: any;
  IsDifferentMailAddress?: boolean;
  IsFavourite?: boolean;
  IsForeigner?: boolean;
  IsPotential?: boolean;
  IsResident?: boolean;
  IssuingCountry?: string;
  IsSuitable?: boolean;
  KE?: boolean;
  KEClientName?: any;
  KnowledgeLevel?: string;
  LandLine?: string;
  LegalEntityId?: any;
  LegalGuardian_contract_relation?: string;
  LegalGuardians?: any[];
  LegalGuardianType?: string;
  MailResidence?: MailResidence;
  MaritalStatus?: string;
  Mifi2Category?: string;
  Mifi2CategoryCode?: string;
  Mifid_competence?: string;
  Mifid_competenceName?: string;
  Name?: string;
  Nature?: string;
  NatureId?: any;
  NumDependants?: number;
  OnboardingInProcess?: number;
  OnboardingStatus?: string;
  Owner?: any;
  Password?: any;
  PerformancePublicDuties?: PerformancePublicDuties;
  Phone?: string;
  Phone2?: string;
  ProfessionalData?: ProfessionalData;
  ProfileId?: number;
  ProfileName?: string;
  ProfileTestSignatureStatus?: any;
  ProfileTestSignatureType?: any;
  QuestionnarieTypes?: any;
  Recipient?: boolean;
  ReferenciaPerfil?: any;
  RegistredCountry?: string;
  Saludation?: string;
  SegmentCode?: any;
  SegmentName?: any;
  ServiceModelCode?: any;
  ServicioAsesoramientoActivado?: boolean;
  Status?: any;
  Surname?: string;
  TaxResidence?: TaxResidence;
  TotalBalance?: number;
  TradesPerYear?: number;
  Type?: string;
  TypeId?: any;
  TypeService?: any;
  ValidateDocExpirationDate?: number;
  ValidatePortfolioOnboardingStatus?: boolean;
  W8Ben?: any;
  W8BENFiscalData?: W8BENFiscalData;
  W9FiscalData?: any;
  YearsTrading?: number;
  MonthlyIncome?: number;
  MonthlyOutcome?: number;
  MonthlyIncomeRankId?: number;
  MonthlyOutcomeRankId?: number;
  SecondNationality?: string;
  YearlyOutcomeRankId?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('ProfessionalData')
export class ProfessionalData {
  AdditionalActivitiesInfo?: string;
  AnnualNetIncome?: string;
  CNAE?: any;
  CompanyActivity?: string;
  CompanyName?: string;
  ContractualStartDate?: string;
  EmployerAddress?: EmployerAddress;
  EmployerBusinessType?: string;
  EmployerBusinessTypeOther?: string;
  EmployerName?: string;
  EmploymentSituation?: string;
  EstimatedPositionKYC?: any;
  IsMultiplesActivities?: any;
  LiquidNetWorth?: string;
  NetWorth?: string;
  NumberOfTransactionsKYC?: any;
  NumberOfTransfersKYC?: any;
  Objective?: string[];
  Position?: string;
  PositionDescripcion?: any;
  PositionIB?: string;
  PositionIBOther?: string;
  PreviousPosition?: any;
  PreviousPositionIndicator?: boolean;
  PurposeKYC?: any;
  RegulatoryDeclarations?: RegulatoryDeclaration[];
  RegulatoryDetail?: RegulatoryDetail;
  StartDateInTheCompany?: string;
  SourceOfFunds?: string;
  SourceOfFundsFreeText?: string;
  SourceOfIncomeFreeText?: string;
  SourceOfIncomes?: SourceOfIncome[];
  Sector?: string;
  Phone2?: string;
  YearlyOutcomeRankId?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('AgentClientData')
export class Agent {
  Code?: string;
  Email?: string;
  FullName?: string;
  Phone?: string;
  UserCode?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('HabitualResidence')
export class HabitualResidence {
  City?: string;
  CityOfBirth?: string;
  Country?: string;
  CountryPersonal?: any;
  DireccionFiscal?: any;
  DireccionFiscalCiudad?: any;
  DireccionFiscalPais?: any;
  DireccionFiscalProvinciaId?: any;
  Door?: string;
  EsDireccionFiscalDiferente?: boolean;
  ExtraDetails?: string;
  Floor?: string;
  HomeId?: any;
  Number?: string;
  PostalCode?: string;
  ProvincePersonal?: any;
  Stair?: string;
  State?: string;
  Street?: string;
  StreetType?: string;
  TaxResidence?: any;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('MailResidenceClientData')
export class MailResidence {
  City?: string;
  CityOfBirth?: any;
  Country?: string;
  CountryPersonal?: any;
  DireccionFiscal?: any;
  DireccionFiscalCiudad?: any;
  DireccionFiscalPais?: any;
  DireccionFiscalProvinciaId?: any;
  Door?: string;
  EsDireccionFiscalDiferente?: boolean;
  ExtraDetails?: string;
  Floor?: string;
  HomeId?: any;
  Number?: string;
  PostalCode?: string;
  ProvincePersonal?: any;
  Stair?: string;
  State?: string;
  Street?: string;
  StreetType?: string;
  TaxResidence?: any;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('PerformancePublicDuties')
export class PerformancePublicDuties {
  ImportantPublicDuties?: string;
  IsImportantPublicDuties?: any;
  IsImportantPublicDutiesRelative?: any;
  PublicDutieEndDate?: string;
  PublicDutieName?: any;
  RelativeRelationship?: any[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('EmployerAddress')
export class EmployerAddress {
  City?: string;
  CityOfBirth?: any;
  Country?: string;
  CountryPersonal?: any;
  DireccionFiscal?: any;
  DireccionFiscalCiudad?: any;
  DireccionFiscalPais?: any;
  DireccionFiscalProvinciaId?: any;
  Door?: any;
  EsDireccionFiscalDiferente?: boolean;
  ExtraDetails?: any;
  Floor?: any;
  HomeId?: any;
  Number?: any;
  PostalCode?: string;
  ProvincePersonal?: any;
  Stair?: any;
  State?: string;
  Street?: string;
  StreetType?: any;
  TaxResidence?: any;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('RegulatoryDeclaration')
export class RegulatoryDeclaration {
  RegulatoryType?: string;
  Active?: boolean;
  Detail?: string;
  PersonName?: string;
  AffiliationRelationship?: string;
  Company?: string;
  CompanyPhone?: string;
  CompanyEmail?: string;
  Street?: string;
  City?: string;
  PostalCode?: string;
  Country?: string;
  State?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
@JsonObject('RegulatoryDetail')
export class RegulatoryDetail {
  Affiliation?: Affiliation;
  RegulatoryDeclarations?: RegulatoryDeclarations[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
@JsonObject('Affiliation')
export class Affiliation {
  Active?: boolean;
  AffiliationRelationship?: string;
  City?: string;
  Company?: string;
  CompanyEmail?: string;
  CompanyPhone?: string;
  Country?: string;
  Detail?: string;
  PersonName?: string;
  PostalCode?: string;
  State?: string;
  Street?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
@JsonObject('RegulatoryDeclarations')
export class RegulatoryDeclarations {
  Active?: boolean;
  Detail?: string;
  RegulatoryType?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('SourceOfIncome')
export class SourceOfIncome {
  Code?: string;
  SourceType?: string;
  Percentage?: string;
  IsUsedForFunds?: string;
  Description?: string;
  PaymentMethod?: number;
  Frequency?: number;
  Country?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('FiscalPurposesCountry')
export class FiscalPurposesCountry {
  CountryName?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('TaxResidence')
export class TaxResidence {
  FiscalPurposesCountries?: FiscalPurposesCountry[];
  IsOtherCountryPersonFiscalPurposes?: boolean;
  IsUSPersonFiscalPurposes?: boolean;
  TINNumber?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('W8BENFiscalData')
export class W8BENFiscalData {
  NonUSIdentification?: string;
  USFiscalInfo?: USFiscalInfo;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('USFiscalInfo')
export class USFiscalInfo {
  IsUSCitizenship?: boolean;
  IsBornInUS?: boolean;
  HasGreenCard?: boolean;
  SubstantialPresence?: boolean;
  IsUSForFiscalPurposes?: boolean;
  FiscalPurposeReason?: string;
  HasRequestedUSPermanentResidency?: boolean;
  ISUSTaxPerson?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('W9FiscalData')
export class W9FiscalData {
  ClasificationType?: string;
  ClasificationTypeDescription?: string;
  CompanyName?: string;
  EmployerIdentification?: any;
  SSN?: string;
  USFiscalInfo?: USFiscalInfo;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
